import {
    faEnvelopeOpen,
    faGavel,
    faGift,
    faHandPointer,
    faTags,
    faTicket,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BranchFormValues } from 'assets/js/pages/engage/workflows/actions/types';
import { BranchConditionEnum } from 'constants/workflows';

interface BranchConditionOptionLabelProps {
    condition?: BranchFormValues['condition'];
}
const BranchConditionOptionLabel = ({ condition }: BranchConditionOptionLabelProps) => {
    switch (condition) {
        case BranchConditionEnum.CONTACTS_TAGS:
            return (
                <>
                    <FontAwesomeIcon icon={faTags} className="text-brand-violet-primary" />
                    Tags
                </>
            );
        case BranchConditionEnum.MESSAGES_OPEN:
            return (
                <>
                    <FontAwesomeIcon icon={faEnvelopeOpen} className="text-brand-violet-primary" />
                    Opened a message
                </>
            );
        case BranchConditionEnum.MESSAGES_CLICK:
            return (
                <>
                    <FontAwesomeIcon icon={faHandPointer} className="text-brand-violet-primary" />
                    Clicked on any link in a message
                </>
            );

        case BranchConditionEnum.DONATION_MADE:
            return (
                <>
                    <FontAwesomeIcon icon={faGift} className="text-brand-violet-primary" />
                    Made a donation
                </>
            );
        case BranchConditionEnum.TICKET_PURCHASED:
            return (
                <>
                    <FontAwesomeIcon icon={faTicket} className="text-brand-violet-primary" />
                    Purchased a ticket
                </>
            );
        case BranchConditionEnum.AUCTION_REGISTERED_TO_BID:
            return (
                <>
                    <FontAwesomeIcon icon={faGavel} className="text-brand-violet-primary" />
                    Registered to bid
                </>
            );
        default:
            return null;
    }
};

export { BranchConditionOptionLabel };
